import React, { FunctionComponent } from 'react';
import { useAppState } from '../hooks';
import { Loading } from '.';

export interface FeatureGateProps {
  feature?: string;
  fallback?: React.ReactNode;
  children?: React.ReactNode;
  negate?: boolean;
}

const FeatureGate: FunctionComponent<FeatureGateProps> = ({
  feature, fallback, children, negate = false,
}: FeatureGateProps) => {
  const { features, isLoading } = useAppState();

  function hasFeature() {
    return !feature || features?.[feature] === true;
  }

  if (isLoading) {
    return (<Loading size={24} />);
  }

  if (negate) {
    return !hasFeature() ? <>{children}</> : <>{fallback}</>;
  }

  return hasFeature() ? <>{children}</> : <>{fallback}</>;
};

export default FeatureGate;
